
import {Usuario} from '@/soganhei'

import http from '@/http/service'

export default function CriarUsuario(payload=Usuario){
 
    if(payload.idUsuario == undefined){
        return http.post("/parceiro/usuarios",payload)
    }else{
        return http.put(`/parceiro/usuarios/${payload.idUsuario}`,payload)
    }

}